import styled from '@emotion/styled'

export const Wrapper = styled.div`
  margin-bottom: 1em;
  flex: 1;
`

export const Label = styled.label`
  display: block;
  margin-bottom: .2em;
`

export const Input = styled.input`
  font: inherit;
  color: inherit;
  width: 100%;
  box-sizing: border-box;
  background: none;
  border: 2px solid currentColor;
  margin: 0;
  padding: .4em .6em;
`

export const Error = styled.span`
  display: block;
  font-size: .8em;
  color: ${props => props.theme.primary.red};
  margin-top: .2em;
`